import {
  Box,
  Button,
  Flex,
  Stack,
  Text
} from '@chakra-ui/react';
import "@fontsource/raleway";
import bgHeroImg from "../../Assets/Images/redswanbg-1-scaled.webp";


export default function LandingPgHero(props) {
  const { onOpenLoginModal } = props;

  return (
    <Stack align="center" px={{ base: "14px", sm: "10vw" }} style={{ backgroundImage: `url(${bgHeroImg})`, backgroundSize: 'cover', backgroundRepeat: "no-repeat", backgroundPosition: "center" }} >
      <Flex justifyContent="space-between" maxW="1140px" w="100%" gap={{ row: 0, column: 0 }} pt={{ base: "30px", sm: "70px" }} pb={{ base: "40px", sm: "130px" }} flexDirection={{ base: "column", lg: "row" }}   >
        <Box color="white" pt={{ base: "30px", lg: "250px" }} >
          <Text fontFamily="Raleway" fontSize={{ base: "36px", lg: "62px" }} textAlign={{ base: "center", lg: "left" }}>Follow the Asset Tokenization</Text>

          <Text fontFamily="Raleway" fontWeight="300" fontSize={{ base: "24px", lg: "36px" }} textAlign={{ base: "center", lg: "left" }}>Simplifying real estate investing</Text>

        </Box>
        <Stack align="center" pt={{ base: "80px", lg: "150px" }} fontSize={{ base: "24px", lg: "36px" }}  >
          <Text width={{ base: "auto", md: "407px" }} fontFamily="Raleway" color="white" textAlign="center" pb="20px">Become an Investor in Asset Tokenization</Text>
          <Button
            _hover={{
              color: "#002B5B",
              bgColor: "white"
            }}
            w={{ base: "104px", md: "204px" }}
            h="50px"
            fontFamily="Raleway"
            bgColor="#002B5B"
            color="white"
            fontSize={{ base: "13px", md: "26px" }}
            p="12px 26px"
            onClick={onOpenLoginModal}
          >
            Invest Now
          </Button>

        </Stack>
      </Flex>
    </Stack>

  );
}